import { PodcastDetail } from '@/modules/player/components/podcast-detail';
import { withMotion } from '../hoc/with-motion';

const AnimatedPage = withMotion(PodcastDetail);

export const roles: string[] = [];
export const path = '/player/pod/:id';
export const element = <AnimatedPage />